// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"73627e4f","540":"82cf3a7b","589":"40b4e745","986":"67b61323"}[chunkId] + ".chunk.js";
};